import { createRouter, createWebHistory } from 'vue-router'
import HomePage from './components/HomePage.vue';
import NotFound from './components/NotFound.vue';
import JoinUs from './components/JoinUs.vue';
import UserLogin from './components/UserLogin.vue';
import UserRegister from './components/UserRegister.vue';
import PasswordResetComponent from './components/PasswordResetComponent.vue';
import ConfirmarEmail from './components/ConfirmarEmail.vue';
import ResetPassword from './components/ResetPassword.vue';
import UserVerifyResend from './components/UserVerifyResend.vue';
import UserDetails from './components/UserDetails.vue';
import CalendarCitaciones from './components/CalendarCitaciones.vue';
import ScanList from './components/ScanList.vue';
import PatientsList from './components/PatientsList.vue';
import NoAutorizado from './components/NoAutorizado.vue';

const routes = [
  {
    path: '/',
    component: HomePage,
    name: 'Home',
    props: true, // This allows you to pass props to the component through route parameters
    meta: {
      requiresAuth: false,
      title: 'EmbryoScan Project'
    }
  },
  {
    path: '/login', component: UserLogin, meta: {
      requiresAuth: false,
      title: 'Login - EmbryoScan Project'
    }
  },
  { path: '/register', component: UserRegister },
  { path: '/perfil', component: UserDetails, meta: { requiresAuth: true } },
  { path: '/no-autorizado', component: NoAutorizado, meta: { requiresAuth: true } },
  {
    path: '/citaciones',
    component: CalendarCitaciones,
    meta: { requiresRoles: ['clinic'] }
  },
    {
    path: '/pacientes',
    component: PatientsList,
    meta: { requiresRoles: ['researcher'] }
  },
  {
    path: '/scans',
    component: ScanList,
    meta: { requiresRoles: ['researcher'] }
  },
  //    { path: '/condiciones-y-privacidad', component: TermsPrivacy },
  //    { path: '/contacto', component: InfoContact },
  { path: '/join-us', component: JoinUs, meta: { requiresAuth: false } },
  { path: '/passreset', name: 'PasswordReset', component: PasswordResetComponent },
  { path: '/reset/:uid/:token', name: 'ResetPassword', component: ResetPassword },
  { path: '/verifyresend', name: 'VerifyResend', component: UserVerifyResend },
  { path: '/confirm-email/:key', name: 'ConfirmarEmail', component: ConfirmarEmail, props: true },
  { path: '/:catchAll(.*)', component: NotFound }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.afterEach((to) => {
  document.title = to.meta.title || 'EmbryoScan Project';
})

export default router
